import axios from 'axios';
import { Donation } from '../types/interfaces'; // Assuming Donation type is in interfaces.ts
import { createAuthenticatedApiClient, setAuthHeader } from '../config/api';

// Create authenticated API client for donation operations
const apiClient = createAuthenticatedApiClient();

/**
 * Interface for paginated donation response
 */
interface DonationResponse {
  donations: Donation[];
  total: number;
  page: number;
  limit: number;
  pages: number;
}

/**
 * Get the current user's donation history
 * @param page Page number for pagination
 * @param limit Number of items per page
 * @returns Promise with donations and pagination info
 */
export const getMyDonationHistory = async (page = 1, limit = 10): Promise<DonationResponse> => {
  try {
    // Ensure auth headers are set
    setAuthHeader(apiClient);
    
    const response = await apiClient.get('/contributor/donations', {
      params: { page, limit }
    });
    
    return response.data as DonationResponse;
  } catch (error) {
    console.error('Error fetching donation history:', error);
    throw error;
  }
};

/**
 * Get donation history for a specific user (admin only)
 * @param userId User ID to fetch donations for
 * @param page Page number for pagination
 * @param limit Number of items per page
 * @returns Promise with donations and pagination info
 */
export const getUserDonationHistory = async (userId: string, page = 1, limit = 10): Promise<DonationResponse> => {
  try {
    // Ensure auth headers are set
    setAuthHeader(apiClient);
    
    const response = await apiClient.get('/admin/donations', {
      params: { userId, page, limit }
    });
    
    return response.data as DonationResponse;
  } catch (error) {
    console.error('Error fetching user donation history:', error);
    throw error;
  }
};

/**
 * Get donation statistics for the current user
 * @returns Promise with donation statistics
 */
export const getMyDonationStats = async () => {
  try {
    // Ensure auth headers are set
    setAuthHeader(apiClient);
    
    const response = await apiClient.get('/contributor/donations/stats');
    
    return response.data;
  } catch (error) {
    console.error('Error fetching donation statistics:', error);
    throw error;
  }
}; 